import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap';
import './earthwork.css';
import { useEarthWorkStore } from '../../../../store/useEarthWorkStore';
import Loader from '../../../Loader';

function EarthWorkBanner() {
    const { banner, getBanner } = useEarthWorkStore()
    const [loading, setLoading] = useState(false)

    const fetchBannerData = async () => {
        setLoading(true)
        await getBanner()
        setLoading(false)
    }

    useEffect(() => {
        if (!banner) {
            fetchBannerData()
        }
    }, [banner, getBanner])
    return (
        <div>
            <Loader loading={loading}>
                <div className="earthwork-banner-section" style={{
                    "--earthWork-bg": banner?.image ? `url(${banner.image})` : ""
                }}>
                    <div className="earthwork-banner-overlay" />
                    <Container className="theme-container">
                        <Row className="align-items-center">
                            <Col md={8} lg={6}>
                                <div className='earthwork-banner-content'>
                                    <p className="section-subtitle mb-xl-2 mb-1">{banner?.subTitle}</p>
                                    <h2 className="section-sub-title mb-xl-3 mb-2 text-uppercase">
                                        {banner?.title}
                                    </h2>
                                    <p className="earthwork-banner-description fontsize-20">
                                        {banner?.description}
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Loader>
        </div>
    )
}

export default EarthWorkBanner
